import React from "react"

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
	variant?: "default" | "outline" | "secondary"
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
	({ className = "", variant = "default", ...props }, ref) => {
		const baseStyles =
			"inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors"

		const variants = {
			default: "bg-primary text-primary-foreground",
			outline: "border border-primary/20 text-primary",
			secondary: "bg-secondary text-secondary-foreground",
		}

		const combinedClassName =
			`${baseStyles} ${variants[variant]} ${className}`.trim()

		return <span ref={ref} className={combinedClassName} {...props} />
	},
)

Badge.displayName = "Badge"
